import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { UtilsWidgetService } from '../services/utils-widget.service';

@Component({
  selector: 'lms-average-progress-widget',
  templateUrl: './average-progress-widget.component.html',
  styleUrls: ['./average-progress-widget.component.scss']
})
export class AverageProgressWidgetComponent implements WidgetComponent, OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() progress: any;
  @Input() key?: string;

  public rangeConfig: any;
  public tooltipText: string;
  private tooltipSubscription: Subscription = new Subscription();

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.key);
    });
  }

  ngOnChanges() {
    this.rangeConfig = {
      keyboard: false,
      block: true,
      grid: true,
      grid_num: 4,
      prettify: (num) => this.prettify(num),
      min: 0,
      max: 100,
      from: this.progress,
      extra_classes: 'margin-bottom',
      hide_min_max: true
    };
  }

  prettify(num) {
    return `<span>${num}%</span>`;
  }

  ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
